import styled from 'styled-components';

export const Title = styled.h1;
export const H1 = styled.h1`
  ${(props) => props.theme.type.base};
  ${(props) => props.theme.type.h1};
`;
export const H2 = styled.h2`
  ${(props) => props.theme.type.base};
  ${(props) => props.theme.type.h2};
`;
export const H3 = styled.h3`
  ${(props) => props.theme.type.base};
  ${(props) => props.theme.type.h3};
`;
export const Copy = styled.p`
  ${(props) => props.theme.type.base};
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  & > a {
    display: inline-block;
    padding: 0 5px;
  }
`;
export const Lead = styled.p`
  ${(props) => props.theme.type.base};
  ${(props) => props.theme.type.lead};
`;
